import { render, staticRenderFns } from "./OutletUserRequests.vue?vue&type=template&id=79c2eec3&"
import script from "./OutletUserRequests.vue?vue&type=script&lang=js&"
export * from "./OutletUserRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports